import React, { Component } from 'react';
import Translator from '../../../../requests/apa/Translator';
import Assets from '../../../../requests/apa/Asset';
import DeviceStorage from '../../../DeviceStorage/DeviceStorage';


class Page02 extends Component {
    constructor(props) {
        super(props);
        this.state = { imageError: false}
    }

    render() {
        const title = Translator.get('LandingPageClaroTv02_Titulo_TextoTitulo', "Incluimos tus apps favoritas");
        const region = DeviceStorage.getItem("region");
        const defaultImage = Assets.get('LandingPageClaroTv02_Metadata02_Imagen', '')
        const image = Assets.get(`LandingPageClaroTv02_Metadata02_Imagen_${region}`, '') || defaultImage;

        return (
            <div className="landing-page_page page-02">
                <div className="content">
                    <h1>{title}</h1>
                    <img src={this.state.imageError ? defaultImage : image} 
                        onError={this.state.imageError ? () => {} : () => {
                            this.setState({imageError: true})
                        }}
                    />
                </div>
            </div>
        )
    }
}

export default Page02;


// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPageSTB/pages/02.jsx